(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationAmenityTemplateClone',
	};

	var form_id = 'reservationamenitytemplateclone-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// character count for the description field
		Adzuki.CharacterCount('#' + form_id + 'description', {
			max  : 100,
			label: '#description-text-count',
		});
	};
}(jQuery, window.Adzuki || {}));
